// eslint-disable-next-line import/prefer-default-export
export const removeWhiteSpace = (value) => (value ? value.replace(/\s/g, '') : '');
